import { defineMessages } from 'react-intl';

export default defineMessages({
    delinquencyWarning: {
        id: 'ml.gateway.views.MLAccountSummary.delinquencyWarning',
        defaultMessage: 'A cancellation for non-payment of premium is pending on policy {policyNumber}. This policy will cancel unless outstanding premium is paid.'
    }
})